import { Col, Row } from 'react-bootstrap';
import { People, Person } from 'react-bootstrap-icons';

import { ReservationTypeCard } from '../../Cards/ReservationTypeCard/ReservationTypeCard';

export const ReservationTypeStep = () => {
  return (
    <>
      <Row className="step-title"> Select Reservation Type</Row>
      <Row>
        <Col className="step-columns">
          <ReservationTypeCard
            title="Single Reservation"
            description="Book a single room for one guest"
            value="single"
            icon={<Person size={40} />}
          />
        </Col>
        <Col className="step-columns">
          <ReservationTypeCard
            title="Group Reservation"
            description="Book multiple rooms for a group"
            value="group"
            icon={<People size={40} />}
          />
        </Col>
      </Row>
    </>
  );
};
